// src/components/organism/AccountOverview/AccountProfile/AccountProfile.tsx
import React, { useCallback } from 'react';
import { Container, Row, Col } from 'shared-portal-component';

import AccountOverviewCard from '@/components/organism/AccountOverview/AccountOverviewCard/AccountOverviewCard';
import type { Address } from '@/types/organization.types';
import '@/components/organism/AccountOverview/AccountProfile/AccountProfile.scss';

interface Props {
  loading?: boolean;
  name: string;
  customerSince?: string;
  phone: string;
  address?: Address;
}

const AccountProfile: React.FC<Props> = ({ loading, name, customerSince, phone, address }) => {
  const handleIconClick = useCallback(() => {
    // open modal later
  }, []);

  return (
    <AccountOverviewCard title="Account Profile" onIconClick={handleIconClick} loading={loading}>
      <Container fluid>
        <Row spacing="none" align="start" className="account-row">
          <Col size="content" className="account-label">Account Name</Col>
          <Col><p className="account-value">{name}</p></Col>
        </Row>

        <Row spacing="none" align="start" className="account-row">
          <Col size="content" className="account-label">Customer since</Col>
          <Col><p className="account-value">{customerSince ?? '-'}</p></Col>
        </Row>

        <Row spacing="none" align="start" className="account-row">
          <Col size="content" className="account-label">Address</Col>
          <Col>
            <p className="account-value">
              {address?.line1}<br />
              {((address?.line2) !== undefined) && (<>{address.line2}<br /></>)}
              {address?.city}, {address?.state}&nbsp;&nbsp;{address?.zip}
            </p>
          </Col>
        </Row>

        <Row spacing="none" align="start" className="account-row">
          <Col size="content" className="account-label">Phone</Col>
          <Col><p className="account-value">{phone}</p></Col>
        </Row>
      </Container>
    </AccountOverviewCard>
  );
};

export default AccountProfile;
